<template>
    <page :busy="busy" :tabs="tabs" class="booking-calendar-single-page">
        <div class="d-flex col-lg-2 pt-3">
            <b-button class="mr-2" @click="resetSettings"
                >Reset to Default</b-button
            >
            <b-button variant="primary" @click="saveSettings">Save</b-button>
        </div>
        <div
            class="d-flex flex-column flex-lg-row justify-content-between overflow-auto h-100"
        >
            <div class="col-lg-3 col-12 pt-3 settings-wrapper">
                <div
                    v-for="groupSetting in groupSettings"
                    :key="groupSetting.label + Math.random()"
                    class="group-setting"
                >
                    <div
                        class="setting-item"
                        v-if="isSettingVisible(settingIndex, groupSetting)"
                    >
                        <span>{{ groupSetting.label }}</span>
                        <div class="setting-input-wrapper">
                            <div
                                v-for="setting in groupSetting.settings"
                                :key="setting.setting_key + Math.random()"
                                class="mr-2"
                            >
                                <div
                                    v-if="
                                        isSettingVisible(settingIndex, setting)
                                    "
                                >
                                    <form-select
                                        v-if="setting.field_type === 'select'"
                                        v-model="setting.setting_val"
                                        :options="setting.options"
                                    />
                                    <form-switch
                                        v-if="setting.field_type === 'switch'"
                                        v-model="setting.setting_val"
                                    />
                                    <b-input-group
                                        v-if="setting.field_type === 'color'"
                                    >
                                        <b-form-input
                                            type="color"
                                            class="color-picker"
                                            :value="setting.setting_val"
                                            @change="
                                                (val) =>
                                                    onColorChange(val, setting)
                                            "
                                        />
                                        <b-input-group-append
                                            v-if="setting.can_clear"
                                        >
                                            <b-button
                                                @click="
                                                    setting.setting_val = ''
                                                "
                                                variant="default"
                                                >Clear</b-button
                                            >
                                        </b-input-group-append>
                                    </b-input-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-9 col-12 iframe-wrapper">
                <div>
                    <form-select
                        v-model="selectedProperty"
                        :options="properties"
                        label="Select Property"
                        class="single-calendar-form-item"
                        @change="setEmbededCode"

                    />
                </div>
                <iframe
                    v-if="iframeSrc && selectedProperty"
                    ref="iframe"
                    class="single-settings-iframe"
                    :src="iframeSrc"
                    :style="{ width: iframeWidth }"
                    marginheight="0"
                    marginwidth="0"
                    allowfullscreen="true"
                    webkitallowfullscreen="true"
                    @load="onIframeLoad"
                ></iframe>
                <div class="d-flex flex-column embeded-code-wrapper">
                    <div
                        :class="{ 'd-none': !isShowPropertyName }"
                        class="form-group"
                    >
                        <label>Embed Code</label>
                        <textarea
                            class="form-control single-calendar-form-item"
                            rows="4"
                            ref="embeded_code_area"
                        >
                        </textarea>
                    </div>
                    <div
                        :class="{ 'd-none': isShowPropertyName }"
                        class="form-group"
                    >
                        <label>Embed Code</label>
                        <textarea
                            class="form-control single-calendar-form-item"
                            rows="4"
                            ref="embeded_code_area_without_name"
                        >
                        </textarea>
                    </div>
                    <b-button
                        class="copy-button"
                        @click="copyToClipboard"
                        variant="default"
                        >Copy!</b-button
                    >
                </div>
            </div>
        </div>
    </page>
</template>


<script>
import API from '../../../api';
import {
    BOOKING_CALENDAR_SETTINGS_LIST,
    BOOKING_CALENDAR_SETTINGS_PROPERTY,
} from '../../../endpoints';
import {
    DEFAULT_SINGLE_SETTINGS,
    SINGLE_SETTINGS_GROUPS,
    DEFAULT_SINGLE_SETTINGS_FOR_RESET,
} from './default-settings';
import formSelect from '../../generic/form-select/form-select.vue';
import formSwitch from '../../generic/form-switch/form-switch.vue';
import FormTextarea from '../../generic/form-textarea/form-textarea.vue';
import {
    indexSettings,
    getSettings,
    groupSettings,
    convertSwitchFieldValue,
} from './shared-methods';

import page from '../../generic/page/page.vue';

export default {
    components: { page, formSelect, formSwitch, FormTextarea },
    computed: {
        iframeSrc() {
            const website = window.website_url;
            const settings = this.settings.map(
                ({ calendar_type, setting_key, setting_val }) => ({
                    calendar_type,
                    setting_key,
                    setting_val:
                        typeof setting_val === 'boolean'
                            ? setting_val
                                ? '1'
                                : '0'
                            : setting_val,
                })
            );
            return `/booking-calendar/websites/${website}/properties/${
                this.selectedProperty
            }/?iframe=LodgixCalendar${Math.random() + 1}&s=${encodeURIComponent(
                JSON.stringify(settings)
            )}&v=${Math.random()}`;
        },
        propertyName() {
            return this.properties.find(
                (item) => item.value === this.selectedProperty
            )?.text;
        },
        isShowPropertyName() {
            return this.settings.find(
                (item) => item.setting_key === 'config-show-property-name'
            )?.setting_val;
        },
        isSmallScreen() {
            return (
                window.innerWidth < 768 ||
                document.body.clientWidth < 768 ||
                document.documentElement.clientWidth < 768
            );
        },
    },
    data() {
        return {
            busy: null,
            tabs: [
                {
                    title: 'Single Property Calendar',
                    route: '/app/booking-calendar/settings/single',
                    active: true,
                },
                {
                    title: 'Multi Property Calendar',
                    route: '/app/booking-calendar/settings/multi',
                    active: false,
                },
            ],
            groupSettings: [],
            selectedProperty: null,
            settings: [],
            settingIndex: null,
            properties: [],
            iframeWidth: null,
        };
    },
    mounted() {
        Promise.all([this.fetchSettings(), this.fetchProperties()]);
        window.addEventListener('resize', this.onIframeLoad);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.onIframeLoad);
    },
    methods: {
        async copyToClipboard() {
            const text = this.isShowPropertyName
                ? this.$refs.embeded_code_area.value
                : this.$refs.embeded_code_area_without_name.value;
            try {
                await navigator.clipboard.writeText(text);
                this.successToast({
                    text: 'Copied to clipboard successfully.',
                });
            } catch (err) {
                this.errorToast({
                    text: 'Something went wrong while copying to clipboard.',
                });
            }
        },
        async fetchProperties() {
            try {
                const { data } = await API.get(
                    BOOKING_CALENDAR_SETTINGS_PROPERTY()
                );
                this.properties = data.map((item) => ({
                    value: item.id,
                    text: item.name,
                }));
                if (this.properties.length) {
                    this.selectedProperty = this.properties[0].value;
                    this.setEmbededCode();
                }
            } catch (e) {
                this.errorToast({ text: 'Could not fetch properties.' });
            }
        },
        async fetchSettings() {
            try {
                this.busy = true;
                const { data } = await API.get(
                    BOOKING_CALENDAR_SETTINGS_LIST()
                );
                this.settings = getSettings(DEFAULT_SINGLE_SETTINGS, data);
                this.settingIndex = indexSettings(this.settings);
                const groupSettingsList = groupSettings(
                    this.settingIndex,
                    SINGLE_SETTINGS_GROUPS
                );
                this.groupSettings = convertSwitchFieldValue(groupSettingsList);
            } catch (e) {
                this.errorToast({ text: 'Could not fetch settings.' });
            } finally {
                this.busy = false;
            }
        },
        isSettingVisible(index, setting) {
            if (setting.visible_switch) {
                const val =
                    typeof setting.visible_switch_value !== 'undefined'
                        ? Boolean(Number(setting.visible_switch_value))
                        : true;
                return index[setting.visible_switch].setting_val === val;
            }
            return true;
        },
        onColorChange(val, setting) {
            setting.setting_val = val;
        },
        onIframeLoad() {
            const MAX_SINGLE_CALENDAR_WIDTH = 556;
            const iframeEl = this.$refs.iframe;
            const rect = iframeEl.parentNode.getBoundingClientRect();
            const newWidth = Math.min(
                Math.floor(rect.width / 7) * 7,
                MAX_SINGLE_CALENDAR_WIDTH
            );
            this.iframeWidth = newWidth + 'px';
            iframeEl.style.height = 650 + 'px';
            if (iframeEl.contentWindow) {
                iframeEl.contentWindow.postMessage(
                    'width=' + (this.isSmallScreen ? newWidth - 15 : newWidth),
                    document.location.origin
                );
            }
        },
        resetSettings() {
            const len = this.settings.length;
            const convertedValueArray = [
                ...DEFAULT_SINGLE_SETTINGS_FOR_RESET,
            ].map((setting) => {
                if (setting.field_type === 'switch') {
                    setting.setting_val = Boolean(Number(setting.setting_val));
                }
                return setting;
            });
            for (let s, i = 0; i < len; i++) {
                s = this.settings[i];
                s.setting_val = convertedValueArray[i].setting_val;
            }
        },
        async saveSettings() {
            try {
                const data = [];
                for (let s, i = 0; i < this.settings.length; i++) {
                    s = this.settings[i];
                    const value =
                        typeof s.setting_val === 'boolean'
                            ? s.setting_val
                                ? '1'
                                : '0'
                            : s.setting_val;
                    data.push({
                        calendar_type: s.calendar_type,
                        setting_key: s.setting_key,
                        setting_val: value,
                    });
                }
                await API.post(BOOKING_CALENDAR_SETTINGS_LIST(), data);
                this.successToast({ text: 'Settings have been saved' });
                this.fetchSettings();
            } catch (e) {
                this.errorToast({ text: 'Could not save settings' });
            }
        },
        setEmbededCode() {
            const selectedPropertyName = this.properties.find(
                (item) => item.value === this.selectedProperty
            );
            this.$refs.embeded_code_area.innerHTML = `&lt;h4 class="lodgixPropertyName" style="text-align:center"&gt;${selectedPropertyName.text}&lt;/h4&gt;&lt;script src="${window.lodgix_origin}/static/booking-calendar/single/iframe/lodgix.min.js"&gt;&lt;/script&gt;&lt;script&gt;new LodgixCalendarSingle(new LodgixOrigin('${window.lodgix_origin}','/booking-calendar/websites/${window.website_url}/properties/${this.selectedProperty}/'))&lt;/script&gt;`;
            this.$refs.embeded_code_area_without_name.innerHTML = `&lt;script src="${window.lodgix_origin}/static/booking-calendar/single/iframe/lodgix.min.js"&gt;&lt;/script&gt;&lt;script&gt;new LodgixCalendarSingle(new LodgixOrigin('${window.lodgix_origin}','/booking-calendar/websites/${window.website_url}/properties/${this.selectedProperty}/'))&lt;/script&gt;`;
        },
    },
};
</script>

<style lang="scss">
.booking-calendar-single-page {
    display: flex;
    flex-direction: column;
    .nav {
        flex-wrap: nowrap !important;
    }
    .lx-page-container {
        overflow-y: hidden;
    }
}
</style>

<style lang="scss" scoped>
@import '~bootstrap/scss/_functions.scss';
@import '~bootstrap/scss/_variables.scss';
@import '~bootstrap/scss/mixins/_breakpoints.scss';

.setting-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
    border-bottom: 1px solid #eee;
    height: 50px;
    .setting-input-wrapper {
        display: flex;
        align-items: center;
        .form-group {
            margin-bottom: 0;
        }
    }
    .color-picker {
        width: 60px !important;
    }
}
.single-settings-iframe {
    border: 0px;
}

.copy-button {
    width: 200px;
}
.embeded-code-wrapper {
    padding-bottom: 60px;
}
.group-setting:last-child {
    margin-bottom: 45px;
}
.settings-wrapper {
    overflow-y: auto;
}
.iframe-wrapper {
    overflow-y: auto;
    scrollbar-width: thin;
    padding-bottom: 60px;
}

@include media-breakpoint-down(xl) {
    .single-calendar-form-item {
        width: 40% !important;
    }
}

@include media-breakpoint-down(md) {
    .settings-wrapper {
        overflow: unset;
    }
    .iframe-wrapper {
        overflow: unset;
    }

    .single-calendar-form-item {
        width: 100% !important;
    }
}
</style>